import { twMerge } from "tailwind-merge"
import { getSubscriberStatusColor } from "../../../../services/functions"

import { StatusDot, Container } from "./styles"

export function Status({ children }) {

  const background = getSubscriberStatusColor(children)

  return (
    <Container>
      <StatusDot style={{ background }}>
        <span style={{ background }} className={twMerge(
          "absolute rounded-full scale-0 w-full h-full",
          "group-data-[status=Cancelado]:animate-ping group-data-[status=Cancelado]:group-hover:!bg-white group-data-[status=Cancelado]:scale-110",
          "group-data-[canceled=true]:animate-ping group-data-[canceled=true]:group-hover:!bg-white group-data-[canceled=true]:scale-110",
          "group-data-[status=Em_atraso]:animate-ping group-data-[status=Em_atraso]:group-hover:!bg-white group-data-[status=Em_atraso]:scale-110",
        )} />
        <span style={{ background }} className="absolute rounded-full w-full h-full" />
      </StatusDot>
      {children}

    </Container>
  )
}
